import { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import LazyLoadImg from "../../../elements/images/LazyLoadImg";
import Container from "../../../utils/Container";
import H2 from "../../../elements/titles/H2";
import H3 from "../../../elements/titles/H3";
import Paragraph from "../../../elements/p/Paragraph";
import Button from "../../../elements/buttons/Button";
import { FiEdit } from "react-icons/fi";
import Alert from "../../../../components/elements/alerts/Alerts";
import noProductsFoundSvg from "../../../../medias/svg/undraw_no_data_re_kwbl.svg";
import modalContext from "../../../../dataManager/context/modalContext";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import Toogle from "../../../elements/form/Toogle";
import { firebaseSignOutAdmin } from "../../../../api/admins/adminApi";
import ProductItem from "./ProductItem";

const Header = () => {
  //context varibles
  const { handleOpenModal } = useContext(modalContext);
  const { currentAdmin, logout } = useContext(currentAdminContext);
  //state variables
  const [isToogleOn, setIsToogleOn] = useState(false);
  const [showAlert, setShowAlert] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (isToogleOn) {
      //logout on firebase
      signOutAdmin();

      //set the current user
      logout();
    }
  }, [isToogleOn]);

  const defaltUserImage =
    "https://firebasestorage.googleapis.com/v0/b/nti-shop.appspot.com/o/admins%2Fdefault-admin-image.jpg?alt=media&token=41048904-008a-4ca2-8293-5a853083e693";

  useEffect(() => {
    if (
      currentAdmin.getName !== "Monsieur xyz" &&
      currentAdmin.getImage !== defaltUserImage
    )
      setShowAlert(false);
  }, [currentAdmin]);

  //sigout
  const signOutAdmin = async () => {
    //go home
    navigate("/");

    const { data, error } = await firebaseSignOutAdmin();

    if (data) setIsToogleOn(false);
  };

  const allSavedProducts = currentAdmin?.getSavedProducts.length ? (
    <div className="mt-3 flex flex-col space-y-3">
      {currentAdmin.getSavedProducts.map((product) => (
        <ProductItem product={product} />
      ))}
    </div>
  ) : (
    <div className="mt-14 flex flex-col items-center">
      <img
        src={noProductsFoundSvg}
        alt={currentAdmin.getName}
        className="w-44 md:w-48"
      />
      <Paragraph classe="mt-1">(aucun article enregistré)</Paragraph>
      <Paragraph size="small" classe="mt-1 text-center max-w-sm">
        Pensez à enregistrer vos articles favoris present dans{" "}
        <Link
          to="/produits"
          className="animate underline hover:text-primary-dark"
        >
          la page de tous les articles
        </Link>{" "}
        en cliquant sur les 3 petits point (...) du produit qui vous intéresse
      </Paragraph>
      <Button link="/produits" classe="mt-8">
        Tous les articles
      </Button>
    </div>
  );
  return (
    <>
      <header className="user-profile-svg marginNavbar separed  h-28 w-full bg-smoot md:h-52"></header>
      <Container classe="bg-smoo mx-auto flex mt-20 md:mt-0 -translate-y-[142px] md:-translate-y-[95px] flex-col items-center">
        <div>
          <LazyLoadImg
            classe="rounded-full w-28 object-cover h-28  md:w-40 md:h-40  mt-92 block border-white  border-4"
            img={currentAdmin.getImage}
            alt="ngimdock"
          />
        </div>
        <div className="text-center">
          <H3>{currentAdmin.getName}</H3>
          <Paragraph size="small">{currentAdmin.getPhone}</Paragraph>
          <div className="mx-auto my-4 flex max-w-[280px] items-center justify-start space-x-1">
            <button
              onClick={() =>
                handleOpenModal("EDIT_USER", "Modifier votre profile", {
                  userId: currentAdmin.getId,
                })
              }
              className="mx-auto flex items-center justify-center space-x-1 rounded-full border-2 border-primary p-1 px-3  text-center font-nunito text-sm text-primary"
            >
              <FiEdit />
              <span>edit profile</span>
            </button>
            <div className="flex h-[30px] items-center space-x-2 text-center font-nunito text-xs text-primary md:text-sm">
              <span>Déconnexion</span>
              <Toogle isToogleOn={isToogleOn} setisToogleOn={setIsToogleOn} />
            </div>
          </div>
          {showAlert && (
            <Alert type="info" classe="mt-2">
              <div className="flex items-center space-x-2 md:space-x-4">
                <Paragraph size="small" classe="text-[#1d4ed8]">
                  Pensez à modifier vos informations de profile
                </Paragraph>
                <IoMdClose
                  onClick={() => setShowAlert(false)}
                  className="cursor-pointer"
                />
              </div>
            </Alert>
          )}
        </div>
        <div className="mt-10 flex w-full flex-col items-center ">
          <H2 classe="text-center">Liste de tous vos articles enregistrés</H2>
          {allSavedProducts}
        </div>
      </Container>
    </>
  );
};

export default Header;
